import { getStoredAuthToken } from '@/lib/auth';
import { apiFetch } from '@/lib/fetch';
import { PlayerServiceClient, getAuthToken, PlatformID } from '@gachamonsters/player-service';

const APP_ID = import.meta.env.VITE_APP_ID || 'chotto-chat';
const PLAYER_SERVICE_HOST = import.meta.env.VITE_PLAYER_SERVICE_HOST || "player-service-dev.gct-internal.net";
const PLAYER_SERVICE_PORT = import.meta.env.VITE_PLAYER_SERVICE_PORT || 443;
const PLAYER_SERVICE_AUTH_URL = `https://${PLAYER_SERVICE_HOST}/api/auth`;
const AUTH_PROVIDER_GOOGLE = 'ggl';

const CLIENT_OPTIONS = {
    host: PLAYER_SERVICE_HOST,
    port: PLAYER_SERVICE_PORT,
    useHTTPS: true,
    retryCount: 1,
    retryTimeout: 1000,
};

export const LS_TOKEN_KEY = "gc:token";
let _client: PlayerServiceClient;

export const getPlayerServiceClient = async () => {
    if (_client) {
        return _client;
    }
    const origFunc = window.getAuthToken
    const tokenFunc = async (): Promise<any> => {
        return getStoredAuthToken().token
    }
    window.getAuthToken = tokenFunc();
    _client = new PlayerServiceClient(CLIENT_OPTIONS);
    window.getAuthToken = origFunc
    return _client;
}

export const requestGuestAccess = async (recaptcha: string) => {
    return await PlayerServiceClient.requestGuestAccess(
        CLIENT_OPTIONS,
        APP_ID,
        'web',
        recaptcha
    )
}

export async function getGachaToken(token: string, provider?: string, platformPlayerId?: string) {
    const options: any = {
        appID: APP_ID,
        platformID: PlatformID.Native,
        identityProvider: provider || AUTH_PROVIDER_GOOGLE, //as of now defaulting to google as provider
        authURL: PLAYER_SERVICE_AUTH_URL,
    };

    if (token) {
        options.signedPayload = token;
    } else {
        options.platformID = "native";
    }
    if (platformPlayerId) {
        options.platformPlayerID = platformPlayerId
    }
    getAuthToken(options);
    const gctAuthToken = await window.getAuthToken;
    return gctAuthToken;
}

export async function getUserInfo(userId: string) {
    const client = await getPlayerServiceClient();
    return await client.loadPlayerByID(userId);
}

export async function updatePlayerData(userId: string, username: string, name: string) {
    await updateUsername(userId, username);
    await updateName(name);
}

async function updateUsername(userId: string, username: string) {
    const client = await getPlayerServiceClient();
    if (username.indexOf("g-") == 0) {
        throw new Error("Username cannot start with g-");
    }
    return await client.updatePlayerName({ id: userId, name: username });
}

/**
 * User data is updated from server as setting from client is not supported.
 */
async function updateName(
    name: string
): Promise<void> {
    return _fetch("/users", "PATCH", { name });
}

async function _fetch(apiUrl: string, method?: string, data?: any) {
    const { token } = getStoredAuthToken();
    try {
        const response = await apiFetch(apiUrl, {
            method: method || "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: data ? JSON.stringify(data) : undefined,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`HTTP error! Status: ${response.status}, Body: ${errorText}`);
        }
        return await response.json();;
    } catch (error) {
        console.error(error);
        throw error
    }
}
